"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableRowHeight = exports.tableFontSize = exports.secondaryFontFamily = exports.primaryFontFamilyString = exports.primaryFontFamily = void 0;
var typography_scss_1 = __importDefault(require("./typography.scss"));
exports.primaryFontFamily = typography_scss_1.default.primary_font_family;
exports.primaryFontFamilyString = typography_scss_1.default.primary_font_family_string;
exports.secondaryFontFamily = typography_scss_1.default.secondary_font_family;
exports.tableFontSize = typography_scss_1.default.table_font_size;
exports.tableRowHeight = typography_scss_1.default.table_row_height;
/**
 * In the typographyConfig is defined default typography settings.
 * It's possible to add or update(but not delete) typography variants(it's object keys).
 * To add the new typography variant to design system please add in the end of the object new addition settings.
 * For example, please update `typographyConfig` with next data:
  `button3: {
      fontWeight: '900',
      fontSize: '50px',
      lineHeight: typography.button_line_height,
      textTransform: 'uppercase',
    },`
 */
var typographyConfig = {
    fontFamily: exports.primaryFontFamily,
    h1: {
        fontWeight: typography_scss_1.default.h1_font_weight,
        fontSize: typography_scss_1.default.h1_font_size,
        lineHeight: typography_scss_1.default.h1_line_height,
    },
    h2: {
        fontWeight: typography_scss_1.default.h2_font_weight,
        fontSize: typography_scss_1.default.h2_font_size,
        lineHeight: typography_scss_1.default.h2_line_height,
    },
    h3: {
        fontWeight: typography_scss_1.default.h3_font_weight,
        fontSize: typography_scss_1.default.h3_font_size,
        lineHeight: typography_scss_1.default.h3_line_height,
    },
    h4: {
        fontWeight: typography_scss_1.default.h4_font_weight,
        fontSize: typography_scss_1.default.h4_font_size,
        lineHeight: typography_scss_1.default.h4_line_height,
    },
    h5: {
        fontWeight: typography_scss_1.default.h5_font_weight,
        fontSize: typography_scss_1.default.h5_font_size,
        lineHeight: typography_scss_1.default.h5_line_height,
    },
    h6: {
        fontWeight: typography_scss_1.default.h6_font_weight,
        fontSize: typography_scss_1.default.h6_font_size,
        lineHeight: typography_scss_1.default.h6_line_height,
    },
    subtitle1: {
        fontWeight: typography_scss_1.default.subtitle1_font_weight,
        fontSize: typography_scss_1.default.subtitle1_font_size,
        lineHeight: typography_scss_1.default.subtitle1_line_height,
    },
    subtitle2: {
        fontWeight: typography_scss_1.default.subtitle2_font_weight,
        fontSize: typography_scss_1.default.subtitle2_font_size,
        lineHeight: typography_scss_1.default.subtitle2_line_height,
    },
    subtitle3: {
        fontWeight: typography_scss_1.default.subtitle3_font_weight,
        fontSize: typography_scss_1.default.subtitle3_font_size,
        lineHeight: typography_scss_1.default.subtitle3_line_height,
    },
    body1: {
        fontFamily: exports.secondaryFontFamily,
        fontWeight: typography_scss_1.default.body1_font_weight,
        fontSize: typography_scss_1.default.body1_font_size,
    },
    body2: {
        fontFamily: exports.secondaryFontFamily,
        fontWeight: typography_scss_1.default.body2_font_weight,
        fontSize: typography_scss_1.default.body2_font_size,
        lineHeight: typography_scss_1.default.body2_line_height,
    },
    body3: {
        fontFamily: exports.secondaryFontFamily,
        fontWeight: typography_scss_1.default.body3_font_weight,
        fontSize: typography_scss_1.default.body3_font_size,
        lineHeight: typography_scss_1.default.body3_line_height,
    },
    body4: {
        fontFamily: exports.secondaryFontFamily,
        fontWeight: typography_scss_1.default.body4_font_weight,
        fontSize: typography_scss_1.default.body4_font_size,
        lineHeight: typography_scss_1.default.body4_line_height,
    },
    button: {
        fontWeight: typography_scss_1.default.button_font_weight,
        fontSize: typography_scss_1.default.button_font_size,
        lineHeight: typography_scss_1.default.button_line_height,
        textTransform: 'initial',
    },
};
exports.default = typographyConfig;
